
//!

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDFeSIA4SpXrPsUi81gssPEKQxq1yQ7lZY",
  authDomain: "util-website.firebaseapp.com",
  projectId: "util-website",
  storageBucket: "util-website.firebasestorage.app",
  messagingSenderId: "890958705942",
  appId: "1:890958705942:web:f39eba55309aef5be88c37",
  measurementId: "G-J2MXV6V81L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);

export const storage = getStorage(app);
export const auth = getAuth(app);